export const RENT_ANALYZER_REQUIRED_FIELDS_TOOLTIP = 'Please add Rent, Bed, Bath and Sq Ft to use Rent Analyzer.';

export const RENT_ANALYZER_LABEL = 'Rent Analyzer';

export function parseRentAnalyzerTierRequirement(value: unknown): number | null {
  if (typeof value === 'boolean' || value === null || value === undefined || value === '') {
    return null;
  }

  const parsedValue = Number(value);

  return Number.isFinite(parsedValue) ? parsedValue : null;
}

export function isRentAnalyzerTierEligible(
  buildingTier: number | null | undefined,
  requiredTier: number | null | undefined,
): boolean {
  if (buildingTier === null || buildingTier === undefined || requiredTier === null || requiredTier === undefined) {
    return false;
  }

  return buildingTier >= requiredTier;
}

export function parseRentAnalyzerNumeric(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const normalizedValue = String(value).replace(/[,$\s]/g, '');
  const parsedValue = Number(normalizedValue);

  return Number.isFinite(parsedValue) ? parsedValue : null;
}

export function isRentAnalyzerInputMissing(values: Array<string | number | null | undefined>): boolean {
  return values.some((value) => parseRentAnalyzerNumeric(value) === null);
}

export function getRentAnalyzerTooltipText(isInputMissing: boolean): string {
  return isInputMissing ? RENT_ANALYZER_REQUIRED_FIELDS_TOOLTIP : RENT_ANALYZER_LABEL;
}
